(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-curated"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.homepage-curated__testimonial-section').forEach((section) => {
  const carousel = section.querySelector('[data-testimonials-carousel]');
  const previous = section.querySelector('[data-testimonial-previous]');
  const next = section.querySelector('[data-testimonial-next]');

  if (!carousel || !previous || !next) return;

  const scrollReviews = (direction) => {
    const card = carousel.querySelector('.homepage-curated__testimonial');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(carousel).columnGap) || 0;
    const cardsPerStep = window.matchMedia('(max-width: 749px)').matches ? 2 : 1;
    carousel.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) * cardsPerStep, behavior: 'smooth' });
  };

  previous.addEventListener('click', () => scrollReviews(-1));
  next.addEventListener('click', () => scrollReviews(1));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-inspo-board"] && !Shopify.designMode) return;
  try {
    
  const updateInspoCards = (section) => {
    const activeFilter = section.querySelector('[data-inspo-filter].is-active');
    const category = activeFilter ? activeFilter.dataset.inspoFilter : 'all';
    const search = section.querySelector('[data-inspo-search]');
    const term = search ? search.value.trim().toLowerCase() : '';

    section.querySelectorAll('[data-inspo-card]').forEach((card) => {
      const matchesCategory = category === 'all' || card.dataset.category === category;
      const matchesSearch = term === '' || card.dataset.searchText.includes(term);
      card.hidden = !matchesCategory || !matchesSearch;
    });
  };

  document.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-inspo-filter]');
    if (!filter) return;
    const section = filter.closest('[data-search-inspo]');
    if (!section) return;

    const update = () => {
      section.querySelectorAll('[data-inspo-filter]').forEach((item) => {
        const active = item === filter;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      updateInspoCards(section);
    };

    if (document.startViewTransition) {
      document.startViewTransition(update);
    } else {
      update();
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-inspo-search]')) return;
    const section = event.target.closest('[data-search-inspo]');
    if (section) updateInspoCards(section);
  });

  const openInspoDeepLink = () => {
    if (!window.location.hash.startsWith('#look-')) return;
    const slug = window.location.hash.slice(6);
    const card = document.querySelector('[data-inspo-slug="' + CSS.escape(slug) + '"]');
    if (!card) return;

    window.requestAnimationFrame(() => {
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  window.addEventListener('load', openInspoDeepLink);
  window.addEventListener('hashchange', openInspoDeepLink);

  } catch(e) { console.error(e); }
})();
})();
